import {Component} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {TranslateService} from "app/translate/translate.service";
import {FilterFormService} from "app/views/filter_form/filter_form.service";
import {EventsService} from "app/lib/EventsService";
import {BaseComponent} from "app/views/base.component";
import {BillingService2} from "../billing.service";


@Component({
	selector: 'zero_day',
	templateUrl: './zero_day.component.html'
})
export class ZeroDayComponent extends BaseComponent {

	tables: any = {
		zero: [],
		noZero: [],
		hasRereg: [],
		noRefeg: [],
	};

	statsLoader: boolean = true;
	
	constructor(
		public service2: BillingService2,
		public activatedRoute: ActivatedRoute,
		public translate: TranslateService,
		public filter: FilterFormService,
		public eventsService: EventsService
	) {
		super(eventsService, service2, activatedRoute, filter, translate);
	}
	
	async getData() {
		await this.getList();
	}

	async getList() {
		const me = this;
		
		const toPercent = function(val) {
			return parseFloat((val * 100).toFixed(2));
		};
		
		me.statsLoader = true;
		
		const months = [
			'2016-09-01 00:00:00', '2017-09-01 00:00:00', '2018-09-01 00:00:00',
			'2019-09-01 00:00:00',
		];
		const tariffs = ['month', '3months', '6months', '12months', '24months'];

		let fp = me.filter.getFilterParams();

		const { stats } = await me.service2.zeroDay.stats(fp).toPromise();
		
		for(const month of months) {
			for(const tariff of tariffs) {
				const item = {
					type: 'data',
					created_month: '',
					month: `сент.${month.substring(0, 4)}`,
					tariff: tariff,
					userCount: 0,
					userPaidCount: 0,
					userPaidCountPercent: 0,
					manualPaidAmount: 0,
					allPaidAmount: 0,
					LTV: 0,
				};
				
				for(const n of Object.keys(me.tables)) {
					const row = stats[n].reduce((prev, curr) => {
						if(curr.created_month === month && curr.tariffVariant === tariff) {
							const rowN = Object.assign({}, item);
							
							for(const key of Object.keys(item)) {
								if(curr.hasOwnProperty(key)) {
									rowN[key] = curr[key];
								}
							}
							
							rowN.userPaidCountPercent = (rowN.userCount > 0 ? toPercent(rowN.userPaidCount / rowN.userCount) : 0); 
							
							return rowN;
						}

						return prev;
					}, item);

					me.tables[n].push(row);
				}
			}

			for(const n of Object.keys(me.tables)) {
				let rowTotal = me.tables[n].reduce((prev, curr) => {
					if(curr.created_month === month) {
						for (const key of Object.keys(prev)) {
							if (curr.hasOwnProperty(key)) {
								prev[key] += curr[key];
							}
						}
					}

					return prev;
				}, {
					userCount: 0,
					userPaidCount: 0,
					userPaidCountPercent: 0,
					manualPaidAmount: 0,
					allPaidAmount: 0,
					LTV: 0,
				});

				rowTotal.userPaidCountPercent = toPercent(rowTotal.userPaidCount / rowTotal.userCount);
				rowTotal.LTV = rowTotal.allPaidAmount / rowTotal.userCount;

				rowTotal = Object.assign({
					type: 'total',
					month: '',
					tariff: 'ВСЕГО',
				}, rowTotal);

				me.tables[n].push(rowTotal);

				me.tables[n].push({
					type: 'space',
					month: '',
					tariff: '',
				});
			}
		}

		me.statsLoader = false;
	}
}
